/**
 * Application form data structure
 */
export interface ApplicationFormData {
  fullName: string;
  email: string;
  company: string;
  role: string;
  linkedinUrl: string;
  useCase: string;
  honeypot: string; // Bot detection field (should remain empty)
}

/**
 * Form validation errors
 */
export interface FormErrors {
  fullName?: string;
  email?: string;
  company?: string;
  role?: string;
  linkedinUrl?: string;
  useCase?: string;
}

/**
 * Form submission state
 */
export enum SubmissionState {
  IDLE = 'idle',
  SUBMITTING = 'submitting',
  SUCCESS = 'success',
  ERROR = 'error',
}
